import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './map.css';

// Corrige el problema de los íconos de los marcadores de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const customIcon = L.icon({
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    iconSize: [32, 52],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
});

const Map = ({ onMarkerClick, filteredPlaces }) => {
    const [userLocation, setUserLocation] = useState(null);
    const mapRef = useRef();

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const location = [position.coords.latitude, position.coords.longitude];
                setUserLocation(location);
                if (mapRef.current) {
                    mapRef.current.setView(location, 16);
                }
            },
            (error) => {
                console.error("Error obteniendo la ubicación del usuario:", error);
            }
        );
    }, []);

    return (
        <div>
            <div className="map-container">
                <br />
                {userLocation && (
                    <MapContainer
                        center={userLocation}
                        zoom={16}
                        style={{ height: "500px", width: "100%", margin: "0 auto"}}
                        whenCreated={(map) => { mapRef.current = map; }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {Array.isArray(filteredPlaces) && filteredPlaces.map((place, idx) => (
                            <Marker
                                key={idx}
                                position={[place.lat, place.lon]}
                                eventHandlers={{ click: () => onMarkerClick(place) }}
                            >
                                <Popup>
                                    <div className='descripcion'>
                                        <strong>{place.nombreL}</strong><br />
                                        Referencia: {place.referencia || 'No disponible'}
                                    </div>
                                </Popup>
                            </Marker>
                        ))}
                        {userLocation && (
                            <Marker className="usuario" position={userLocation} icon={customIcon}>
                                <Popup>
                                    <strong>Tu ubicación</strong>
                                </Popup>
                            </Marker>
                        )}
                    </MapContainer>
                )}
            </div>
        </div>
    );
};

export default Map;
